<i18n src="@/locales/components/views/customer/query/basic_containers/show_container/container_files.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_attachment.yml" lang="yaml"></i18n>
<template>
  <div class="my-8" v-if="container_attachments.length > 0">
    <div class="panel-header-title">{{ $t("labels.title") }}</div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <th scope="col" class="table-header-cell">
                  {{
                    $t(
                      "model.container_attachment.exporter_process_container_file_id"
                    )
                  }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.container_attachment.container_attach_name") }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </thead>
              <tbody class="table-body">
                <template
                  v-for="container_file in container_files"
                  :key="container_file.id"
                >
                  <!-- <tr
                    v-if="containerAttachments(container_file.id).length == 0"
                    class="table-row"
                  >
                    <td class="table-cell">
                      {{ $t("labels.no_attachments") }}
                    </td>
                  </tr> -->
                  <tr
                    class="table-row"
                    v-for="attach in containerAttachments(container_file.id)"
                    :key="attach.id"
                  >
                    <td class="table-cell">
                      {{ container_file.name }}
                    </td>
                    <td class="table-cell">
                      {{ attach.container_attach.blob.filename }}
                    </td>
                    <td class="table-cell-action">
                      <button
                        class="btn-white inline-flex"
                        @click.prevent="downloadContainerAttachment(attach)"
                      >
                        <i
                          :class="[
                            'fa-solid  ',
                            attach.downloading ? ' fa-sync fa-spin' : ' fa-download',
                          ]"
                        ></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/customer/requesters/query/basic_containers/show_container.js";
export default {
  props: {
    customer_id: {
      required: true
    },
    container: {
      type: Object,
      required: true,
    },
  },
  computed: {
    container_files: function () {
      if (this.container)
        return (
          this.container.agro_exporter_process
            .exporter_process_container_files ?? []
        );
      return [];
    },
    container_attachments: function () {
      if (this.container) return this.container.container_attachments ?? [];
      return [];
    },
  },
  data: function () {
    return {};
  },
  methods: {
    downloadContainerAttachment: async function (container_attachment) {
      if (container_attachment.downloading) return;
      container_attachment.downloading = true;
      try {
        var response = await Requester.downloadContainerAttachment(
          this.customer_id,
          container_attachment.id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          container_attachment.container_attach.blob.filename
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      container_attachment.downloading = false;
    },
    containerAttachments: function (exporter_process_container_file_id) {
      return this.container_attachments.filter(
        (container_attachment) =>
          container_attachment.exporter_process_container_file_id ===
          exporter_process_container_file_id
      );
    },
  },
};
</script>

<style>
</style>
